// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


// api
import * as commodity from '@/api/commodity.js'
import * as commodityCategory from '@/api/commodityCategory.js'
import * as commodityInputOrder from '@/api/commodityInputOrder.js'
import * as commodityLossOrder from '@/api/commodityLossOrder.js'
import * as commodityOutputOrder from '@/api/commodityOutputOrder.js'
import * as commodityQuantityDetail from '@/api/commodityQuantityDetail.js'
// import * as commoditySnapshot from '@/api/commoditySnapshot.js'
import * as commoditySpec from '@/api/commoditySpec.js'
import * as customer from '@/api/customer.js'
import * as customerBalanceDetail from '@/api/customerBalanceDetail.js'
// import * as customerFollowUp from '@/api/customerFollowUp.js'
// import * as customerFollowUpDetail from '@/api/customerFollowUpDetail.js'
// import * as customerFollowUpRemind from '@/api/customerFollowUpRemind.js'
// import * as customerPool from '@/api/customerPool.js'
import * as dataDict from '@/api/dataDict.js'
import * as dataDictItem from '@/api/dataDictItem.js'
import * as dynamicKanban from '@/api/dynamicKanban.js'
import * as enums from '@/api/enum.js'
import * as expenseOrder from '@/api/expenseOrder.js'
import * as expRequest from '@/api/expRequest.js'
import * as extField from '@/api/extField.js'
import * as fundAccount from '@/api/fundAccount.js'
import * as fundAccountDetail from '@/api/fundAccountDetail.js'
import * as fundAccountTransferOrder from '@/api/fundAccountTransferOrder.js'
import * as fundCollectOrder from '@/api/fundCollectOrder.js'
import * as fundPayOrder from '@/api/fundPayOrder.js'
import * as organization from '@/api/organization.js'
import * as otherIncomeOrder from '@/api/otherIncomeOrder.js'
import * as preCollectOrder from '@/api/preCollectOrder.js'
import * as prePayOrder from '@/api/prePayOrder.js'
import * as printer from '@/api/printer.js'
import * as purchaseOrder from '@/api/purchaseOrder.js'
import * as purchaseReturnOrder from '@/api/purchaseReturnOrder.js'
import * as saleOrder from '@/api/saleOrder.js'
import * as saleReturnOrder from '@/api/saleReturnOrder.js'
import * as smsRecord from '@/api/smsRecord.js'
import * as supplier from '@/api/supplier.js'
import * as supplierBalanceDetail from '@/api/supplierBalanceDetail.js'
import * as sysConfig from '@/api/sysConfig.js'
import * as sysMenu from '@/api/sysMenu.js'
import * as sysRole from '@/api/sysRole.js'
import * as tenant from '@/api/tenant.js'
import * as tenantPersonalConfig from '@/api/tenantPersonalConfig.js'
import * as user from '@/api/user.js'
import * as userPersonalConfig from '@/api/userPersonalConfig.js'
import * as versionRecord from '@/api/versionRecord.js'
import * as wareHouse from '@/api/wareHouse.js'
import * as customerGroup from '@/api/customerGroup.js'
import * as customerType from '@/api/customerType.js'
import * as customizeOrder from '@/api/customizeOrder.js'
import * as customizePurchaseOrder from '@/api/customizePurchaseOrder.js'
import * as customizeCollectOrder from '@/api/customizeCollectOrder.js'
import * as customizePayOrder from '@/api/customizePayOrder.js'
import * as customizeOutputOrder from '@/api/customizeOutputOrder.js'
import * as customizeInputOrder from '@/api/customizeInputOrder.js'
import * as commodityTransferOrder from '@/api/commodityTransferOrder.js'




Vue.prototype.$api = {
  ...commodity, ...commodityCategory, ...commodityInputOrder, ...commodityLossOrder, ...commodityOutputOrder,
  ...commodityQuantityDetail, ...commoditySpec,
  // ...commoditySnapshot,
  ...customer, ...customerBalanceDetail,
  // ...customerFollowUp,
  // ...customerFollowUpDetail, ...customerFollowUpRemind, ...customerPool,
  ...dataDict, ...dataDictItem,
  ...dynamicKanban, ...enums, ...expenseOrder, ...expRequest, ...extField, ...fundAccount, ...fundAccountDetail,
  ...fundAccountTransferOrder, ...fundCollectOrder, ...fundPayOrder, ...organization, ...otherIncomeOrder,
  ...preCollectOrder, ...prePayOrder, ...printer, ...purchaseOrder, ...purchaseReturnOrder, ...saleOrder,
  ...saleReturnOrder, ...supplier, ...supplierBalanceDetail, ...sysConfig, ...sysMenu,
  ...sysRole, ...tenantPersonalConfig, ...user, ...userPersonalConfig, ...versionRecord,
  ...smsRecord, ...tenant, ...wareHouse, ...customerGroup, ...customerType, ...customizeOrder, ...customizePurchaseOrder,
  ...customizeCollectOrder, ...customizePayOrder, ...customizeOutputOrder, ...customizeInputOrder, ...commodityTransferOrder
}

//font
import './assets/font/iconfont.css';

// elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// // 修改 el-dialog 默认点击遮照为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.closeOnPressEscape.default = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

// echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// vue-fragment
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// 打印
import print from 'print-js'
Vue.prototype.$print = print;

// 时间处理
import moment from 'moment'
Vue.prototype.$moment = moment;

// xlsx解析文件
import * as XLSX from "xlsx";
Vue.prototype.$XLSX = XLSX;

// 环境变量
let envConfig = process.env;
Vue.prototype.$envConfig = envConfig;

// 自动引入处理组件插件
import componentsList from './utils/componentsRegister';
Vue.use(componentsList);

// json2Excel
import toExcel from './utils/excel'
Vue.prototype.$toExcel = toExcel

// rule
import * as ruleUtil from './utils/ruleUtil'
Vue.prototype.$ruleUtil = ruleUtil;

// storage
import * as storageUtil from './utils/storageUtil'
Vue.prototype.$storageUtil = storageUtil;

// jsTool
import * as jsTool from './utils/jsTool'
Vue.prototype.$jsTool = jsTool;

// 全局水印功能
import VueWatermark from 'vue-watermark';
Vue.use(VueWatermark);

// vuex
import store from './store/index'
Vue.prototype.$store = store;

// axios的finally
require("promise.prototype.finally").shim();

// hasPermi指令
Vue.directive('hasPermi', {
  inserted: function (el, binding, vnode) {
    const { value } = binding
    const all_permission = "*:*:*";
    const permissions = storageUtil.getPermissions();

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermissions = permissions.some(permission => {
        return all_permission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
})

Vue.directive('fmtype', {
  // 当绑定了指令的这个HTML元素插入到父元素上时触发(在这里父元素是 `div#app`)**.但不保证,父元素已经插入了 DOM 文档.**
  inserted: function (el, binding, vnode) {
    const { value, expression } = binding;
    if (value) {
      el.style.color = Vue.prototype.$jsTool.getColor(value);
    }
  }
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js